module.exports = __webpack_public_path__ + "img/Nano.c3fce194.jpg";